export default {
  title: "Monitoring",
  refresh: "Actualiser",
  loading: "Chargement des déploiements...",

  // Filtres
  filters: "Filtres",
  clearFilters: "Effacer les filtres",
  architecture: "Architecture",
  allArchitectures: "Toutes les architectures",
  environment: "Environnement",
  allEnvironments: "Tous les environnements",
  status: "Statut",
  allStatuses: "Tous les statuts",

  // Statistiques
  stats: {
    totalDeployments: "Déploiements totaux",
    architecturesDeployed: "Architectures déployées",
    successfulDeployments: "Déploiements réussis",
    failedDeployments: "Déploiements échoués",
    inProgressDeployments: "En cours",
    totalEstimatedCost: "Coût total estimé",
    avgDeploymentTime: "Temps moyen de déploiement",
    byEnvironment: "Statistiques par environnement",
    total: "total",
    deployed: "déployé",
    failed: "échoué",
    perMonth: "/mois"
  },

  // Liste des déploiements
  deployments: "Déploiements",
  noDeployments: "Aucun déploiement trouvé",
  noDeploymentsText: "Commencez par générer l'infrastructure Terraform pour une architecture.",
  unknownArchitecture: "Architecture inconnue",

  // Statuts de déploiement
  statuses: {
    pending: "En attente",
    generating: "Génération",
    generated: "Généré",
    planning: "Planification",
    planned: "Planifié",
    applying: "Application",
    deployed: "Déployé",
    failed: "Échoué",
    destroying: "Destruction",
    destroyed: "Détruit"
  },

  // Résumé du plan
  planSummary: "Résumé du plan",
  toAdd: "à ajouter",
  toChange: "à modifier",
  toDestroy: "à détruire",

  // Résumé de l'application
  applySummary: "Résumé de l'application",
  added: "ajouté",
  changed: "modifié",
  destroyed: "détruit",

  // Ressources
  resourcesDeployed: "Ressources déployées",
  moreResources: "de plus",

  // Chronologie
  timeline: {
    started: "Démarré",
    planned: "Planifié",
    deployed: "Déployé",
    destroyed: "Détruit"
  },

  // Coût
  estimatedCost: "Coût estimé",
  month: "mois",

  // Actions
  deploy: "Déployer",
  destroy: "Détruire",
  delete: "Supprimer",
  viewPipeline: "Voir le pipeline",

  // Confirmations
  confirmDeploy: "Êtes-vous sûr de vouloir déployer l'infrastructure sur {{env}} ? Cela créera de vraies ressources cloud et peut générer des coûts.",
  confirmDestroy: "Êtes-vous sûr de vouloir détruire l'infrastructure sur {{env}} ? Cette action est irréversible et supprimera toutes les ressources déployées.",
  confirmDelete: "Êtes-vous sûr de vouloir supprimer cet enregistrement de déploiement ? Cela n'affectera pas les ressources déployées.",

  // Messages
  deployStarted: "Déploiement démarré avec succès",
  deployFailed: "Échec du démarrage du déploiement",
  destroyStarted: "Destruction démarrée avec succès",
  destroyFailed: "Échec du démarrage de la destruction",
  deleteSuccess: "Déploiement supprimé avec succès",
  deleteFailed: "Échec de la suppression du déploiement"
};
